import React, { createContext, useContext, useState } from 'react';

const PageTitleContext = createContext();

export const PageTitleProvider = ({ children }) => {
	const [titles, setTitles] = useState({}); // { [route]: title }
	const [descriptions, setDescriptions] = useState({}); // { [route]: description }

	// Set or update a title for a route
	const setPageTitle = (route, title) => {
		setTitles((prev) => ({ ...prev, [route]: title }));
	};

	// Set or update a description for a route
	const setPageDescription = (route, description) => {
		setDescriptions((prev) => ({ ...prev, [route]: description }));
	};

	// Get a title for a route
	const getPageTitle = (route) => titles[route];

	// Get a description for a route
	const getPageDescription = (route) => descriptions[route] || '';

	return (
		<PageTitleContext.Provider
			value={{
				titles,
				setPageTitle,
				getPageTitle,
				descriptions,
				setPageDescription,
				getPageDescription,
			}}>
			{children}
		</PageTitleContext.Provider>
	);
};

export const usePageTitleContext = () => useContext(PageTitleContext);
